import React, { forwardRef, useMemo } from "react";
import PropTypes from "prop-types";

import "./index.scss";

export const WPBUTTON_VARIANTS = {
  text: "text",
  contained: "contained",
  outlined: "outlined",
};

export const WPBUTTON_SIZES = {
  small: "small",
  medium: "medium",
  large: "large",
};

export const WPBUTTON_TYPES = {
  primary: "primary",
  secondary: "secondary",
  danger: "danger",
  warning: "warning",
};

const WPButton = forwardRef(
  ({ id, name, variant, type, size, children, onClick, disabled, customClass }, ref) => {
    const handleClick = (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      onClick?.({ target: { id, name: name || id } });
    };

    const cssClasses = useMemo(
      () => `wp-btn wp-btn__${variant}--${type} wp-btn--${size} ${customClass || ""}`,
      [variant, type, size, customClass]
    );

    return (
      <button
        ref={ref}
        id={id}
        name={name || id}
        onClick={handleClick}
        className={cssClasses}
        disabled={disabled}
        type="button"
      >
        {children}
      </button>
    );
  }
);

WPButton.displayName = "WPButton";

WPButton.propTypes = {
  id: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(WPBUTTON_VARIANTS)),
  type: PropTypes.oneOf(Object.values(WPBUTTON_TYPES)),
  size: PropTypes.oneOf(Object.values(WPBUTTON_SIZES)),
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

WPButton.defaultProps = {
  variant: WPBUTTON_VARIANTS.contained,
  type: WPBUTTON_TYPES.primary,
  size: WPBUTTON_SIZES.medium,
};

export default WPButton;
